export class SecretRefInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "aws",
            "baseName": "aws",
            "type": "AwsSecretsManagerRefInput",
            "format": ""
        },
        {
            "name": "gcp",
            "baseName": "gcp",
            "type": "GcpSecretManagerRefInput",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SecretRefInput.attributeTypeMap;
    }
    constructor() {
    }
}
